import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=742a2874&scoped=true"
import script from "./Get.vue?vue&type=script&lang=js"
export * from "./Get.vue?vue&type=script&lang=js"
import style0 from "./Get.vue?vue&type=style&index=0&id=742a2874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a2874",
  null
  
)

export default component.exports